import sb from '@sb/util'
import lo from 'lodash'
import store from '@sb/store'
import LexicalEditor from '../commons/lexical-editor.js'
const unassignedAvatar = require('../assets/img/unassigned.png')

import {getTicketTypeName, getTicketStateInfo} from './com.js'
import {computeErrorMessage} from '../commons/compute_error_message.js'

import DueDateDropdown from './due_date_dropdown.js'

export default {
	name: 'edit-ticket-modal',
	props: ['open', 'ticket'],
	data() {
		return {
			loading: false,
			ticketData: {},
			initNote: {
				format: 'html',
				text: '',
			},

			isContinueCreate: false,
		}
	},

	watch: {
		open() {
			if (this.open) {
				this.resetTicketData()
			}
		},
	},

	computed: {
		isEdit() {
			return lo.get(this.ticket, 'id') && lo.get(this.ticket, 'id') !== 'new'
		},
	},

	mounted() {
		//this.setTitleInputHeight()
	},

	methods: {
		async resetTicketData() {
			let ticketData = {}
			if (this.isEdit) {
				let id = this.ticket.id
				this.loading = true
				await store.fetchTickets([id], true)
				this.loading = false
				let ticket = store.matchTicket(id) || {id}
				ticketData = {...ticket, ...this.ticket}
			} else {
				ticketData = lo.cloneDeep(this.ticket)
				if (!ticketData.state) ticketData.state = 'unassigned'
			}

			if (!ticketData.type_id) {
				let types = this.getAvailableTicketTypes()
				ticketData.type_id = lo.get(types, '0.id')
			}

			this.ticketData = ticketData
			this.initNote = lo.get(ticketData, 'description') || {format: 'html', text: ''}
			this.compareNote = lo.cloneDeep(this.initNote)
			this.compareTicket = lo.cloneDeep(ticketData)
			await this.$nextTick()
			this.$refs.note_input && this.$refs.note_input.setInitialContent()
			this.tryFocus()
		},

		async resetDataWhenContinueCreate() {
			this.initNote = {
				format: 'html',
				text: '',
			}
			let $note_input = this.$refs.note_input
			await this.$nextTick()
			this.$refs.note_input && this.$refs.note_input.setInitialContent()
			this.ticketData = {...this.ticketData, title: ''}
			this.tryFocus()
		},

		async tryFocus() {
			await this.$nextTick()
			this.$refs.title_input && this.$refs.title_input.focus()
		},

		async closeModal() {
			let isChanged = !lo.isEqual(this.ticketData, this.compareTicket) || !lo.isEqual(this.initNote, this.compareNote)
			if (isChanged) {
				let cf = await this.$confirm({
					title: this.$t('unsaved'),
					description: this.$t('unsave_changed'),
				})

				if (!cf) return
			}
			this.$emit('close')
		},

		setTitleInputHeight(force) {
			let $input = this.$refs.title_input
			if ($input) {
				$input.style.height = 'auto' // must set auto first because scrollHeight doesnt reset if 2line => 1line
				$input.style.height = $input.scrollHeight + 'px'
			}
		},

		onChangeTitle(e) {
			//e.target.style.height = e.target.scrollHeight + 'px'
			let ticket = lo.cloneDeep(this.ticketData)
			ticket.title = e.target.value
			this.ticketData = ticket
			this.setTitleInputHeight()
		},

		renderTitle() {
			let cls = 'edit_ticket_modal_form_title_input'

			return (
				<textarea
					value={this.ticketData.title}
					vOn:input={this.onChangeTitle}
					ref='title_input'
					class={cls}
					placeholder={this.$t('add_title')}
					rows='1'
				></textarea>
			)
		},

		renderNote() {
			return (
				<LexicalEditor
					class='edit_ticket_modal_form_desc_editor'
					placeholder={this.$t('add_description')}
					useMention
					useAutoLink
					html
					no_preview_mode
					initMessage={this.initNote}
					ref='note_input'
					vOn:change={(msg) => this.onChangeNoteDesc(msg)}
				/>
			)
		},

		onChangeNoteDesc(msg) {
			this.initNote = msg
		},

		async submit() {
			//return this.testCreate()
			//if (!this.loading) return
			if (this.saving) return

			this.saving = true
			let res
			let ticket = {
				...this.ticketData,
				description: this.initNote,
			}
			if (this.isEdit) {
				res = await store.updateTicket(ticket)
			} else {
				res = await store.createTicket(ticket)
			}
			this.saving = false
			if (res.error) {
				let errorMsg = computeErrorMessage(lo.get(res, 'body', {}))
				this.$showError(errorMsg, 5000)
				return
			}
			this.$showSuccess(this.$t('success'))
			if (this.isContinueCreate) {
				this.resetDataWhenContinueCreate()
			} else {
				this.$emit('close')
				this.$emit('success', res)
			}
		},

		onChange(obj) {
			this.ticketData = {...this.ticketData, ...obj}
		},

		renderPriority() {
			let $content = (
				<div class='d-flex align-items-center' key='no_priority'>
					<Icon name='antenna-bars-1' class='mr-2 text__secondary' size='16' style='position: relative; top: -4px;' />
					{this.$t('no_priority')}
				</div>
			)
			if (this.ticketData.priority === 'urgent') {
				$content = (
					<div class='d-flex align-items-center' key='urgent_priority'>
						<Icon name='alert-square-filled' class='mr-2 text__danger' size='16' />
						{this.$t('urgent')}
					</div>
				)
			}
			if (this.ticketData.priority === 'medium') {
				$content = (
					<div class='d-flex align-items-center' key='medium_priority'>
						<Icon name='antenna-bars-5' stroke-width='2' class='mr-2 text__secondary' size='16' />
						{this.$t('medium_priority')}
					</div>
				)
			}

			let items = [
				{
					id: '',
					icon: <Icon name='antenna-bars-1' size='16' class='text__secondary' style='position: relative; top: -6px' />,
					label: this.$t('no_priority'),
				},
				{
					id: 'medium',
					icon: <Icon name='antenna-bars-5' stroke-width='2' size='16' class='text__secondary' />,
					label: this.$t('medium_priority'),
				},
				{
					id: 'urgent',
					icon: (
						<Icon name='alert-square-filled' class='text__danger' size='16' style='position: relative; top: -2px' />
					),
					label: this.$t('urgent'),
				},
			]
			return (
				<Dropdown
					mode='custom'
					class='ml-3'
					items={items}
					vOn:select={(item) => this.onChange({priority: item.id})}
					dropdown_width={200}
					style='overflow: hidden'
				>
					<div class='btn btn__sm btn__white align-items-center' style='display: inline-flex'>
						{$content}
						<Icon name='chevron-down' stroke-width='2' size='16' class='text__muted ml-3' />
					</div>
				</Dropdown>
			)
		},

		renderAssignee() {
			let assignee = lo.get(this.ticketData, 'assignee')
			let $assignee = (
				<div class='d-flex align-items-center'>
					<img width='18' src={unassignedAvatar} style='border-radius: 50%' />
					<div class='ml-2 text__truncate'>{this.$t('unassigned')}</div>
				</div>
			)
			if (assignee) {
				let agent = lo.get(store.matchAgent(), assignee, {})
				$assignee = (
					<div class='d-flex align-items-center'>
						<Avatar notooltip agent={agent} size='18' />
						<div class='ml-2 text__truncate' title={sb.getAgentDisplayName(agent)}>
							{sb.getAgentDisplayName(agent)}
						</div>
					</div>
				)
			}

			let agents = lo.filter(store.matchAgent(), (agent) => agent.type === 'agent' && agent.state === 'active')
			let items = lo.map(agents, (agent) => ({
				id: agent.id,
				img: agent.avatar_url || sb.getAgentDefaultAvatarUrl(agent),
				label: sb.getAgentDisplayName(agent),
			}))

			return (
				<Dropdown
					mode='custom'
					items={items}
					vOn:select={(item) => this.onSelectAssignee(item.id)}
					dropdown_width={200}
					style='overflow: hidden'
				>
					<div class='btn btn__sm btn__white align-items-center' style='display: inline-flex'>
						{$assignee}
						<Icon name='chevron-down' stroke-width='2' size='16' class='text__muted ml-3' />
					</div>
				</Dropdown>
			)
		},

		onSelectAssignee(agentid) {
			let obj = {
				assignee: agentid,
			}
			let currentState = lo.get(this.ticketData, 'state')
			if (!currentState || currentState === 'unassigned') obj.state = 'open'
			this.onChange(obj)
		},

		renderStatus() {
			let ticket = this.ticketData
			let {type, text} = getTicketStateInfo(ticket)
			let $content = (
				<div class='d-flex align-items-center' key='status_new'>
					<Icon name='circle-filled' class={`mr-2 text__${type}`} size='16' />
					{text}
				</div>
			)

			let items = lo.map(['open', 'hold', 'closed'], (state) => {
				let {type, text} = getTicketStateInfo({state})
				return {
					id: state,
					icon: <Icon name='circle-filled' size='16' class={`text__${type}`} />,
					label: text,
				}
			})
			return (
				<Dropdown
					mode='custom'
					class='ml-3'
					items={items}
					vOn:select={(item) => this.onChange({state: item.id})}
					dropdown_width={150}
					style='overflow: hidden'
				>
					<div class='btn btn__sm btn__white align-items-center' style='display: inline-flex'>
						{$content}
						<Icon name='chevron-down' stroke-width='2' size='16' class='text__muted ml-3' />
					</div>
				</Dropdown>
			)
		},

		toggleContinueCreate() {
			this.isContinueCreate = !this.isContinueCreate
		},

		getAvailableTicketTypes() {
			let types = lo.filter(
				store.matchTicketType(),
				(type) => lo.find(type.members, (member) => member.id === store.me().id) && !type.archived,
			)
			// defaylt type have created nanoseconds so must use getMS
			types = lo.orderBy(types, [(type) => sb.getMs(type.created)], ['asc'])
			return types
		},
		clearFileInput(e) {
			e.target.value = ''
		},

		async addLocalFiles(e, type) {
			let $editor = this.$refs.note_input
			if ($editor && $editor.addLocalFiles && typeof $editor.addLocalFiles === 'function') {
				$editor.addLocalFiles(e, type)
			}
		},

		renderDueDate() {
			let $content = (
				<div class='d-flex align-items-center' key='no_priority'>
					<Icon name='calendar' class='mr-2 text__secondary' size='16' />
					{this.$t('set_due_date')}
				</div>
			)

			return (
				<DueDateDropdown
					mode='custom'
					class='ml-3'
					vOn:select={(item) => this.onChange({priority: item.id})}
					style='overflow: hidden'
				>
					<div class='btn btn__sm btn__white align-items-center' style='display: inline-flex'>
						{$content}
					</div>
				</DueDateDropdown>
			)
		},
	},

	render() {
		let style = 'width: 720px; position: relative; height: 540px;'
		let items = this.getAvailableTicketTypes()
		items = lo.map(items, (item) => ({
			id: item.id,
			label: getTicketTypeName(item),
		}))
		let selectedType = store.matchTicketType()[this.ticketData.type_id] || {}

		return (
			<div class={{modal: true, modal__hide: !this.open}} style='z-index: 200'>
				<div class='modal__overlay' vOn:click={this.closeModal} />
				<div class='modal__container' style='overflow: unset'>
					<div class='modal__background'>
						<div class='modal_content' style={style}>
							{this.loading ? (
								<div style='position: absolute; inset: 0' class='d-flex align-items-center justify-content-center'>
									<Spinner mode='blue' size='32' />
								</div>
							) : (
								<div class='edit_ticket_modal_form'>
									<input type='file' ref='file_input' multiple style='display: none;' />
									<div class='d-flex align-items-center'>
										{lo.size(items) > 0 && (
											<Fragment>
												<Dropdown
													mode='custom'
													disabled={this.isEdit}
													items={items}
													class='mr-2'
													dropdown_width={200}
													vOn:select={(item) => this.onChange({type_id: item.id})}
												>
													<div
														class={{
															btn: true,
															btn__sm: true,
															btn__white: !this.isEdit,
															btn__light: this.isEdit,
															'align-items-center': true,
														}}
														style='display: inline-flex; max-width: 200px; overflow: hidden'
													>
														<div class='flex__1 text__truncate' title={getTicketTypeName(selectedType)}>
															{getTicketTypeName(selectedType)}
														</div>
														<Icon name='chevron-down' stroke-width='2' size='18' class='text__muted ml-3' />
													</div>
												</Dropdown>
												<Icon name='chevron-right' class='mr-2 text__muted' size='16' />
											</Fragment>
										)}
										<div class='text__muted'>{this.isEdit ? this.$t('edit_ticket') : this.$t('create_ticket')}</div>
										<Icon name='x' size='18' class='btn__close ml-auto' vOn:click={this.closeModal} />
									</div>
									{this.renderTitle()}
									{this.renderNote()}
									<div class='mt-4 d-flex'>
										{this.renderAssignee()}
										{this.renderStatus()}
										{this.renderPriority()}
										{this.renderDueDate()}
									</div>
								</div>
							)}
						</div>
						<div class='edit_ticket_modal_footer'>
							<div class='d-flex align-items-center'>
								<div class='flex__1 mr-4'>
									<input
										type='file'
										ref='file_input'
										multiple
										style='display: none;'
										vOn:click={this.clearFileInput}
										vOn:change={this.addLocalFiles}
									/>
									<div
										class='link text__sm link__secondary d-inline-flex align-items-center'
										vOn:click={() => this.$refs.file_input.click()}
									>
										<Icon name='paperclip' size='16' class='mr-2' />
										{this.$t('add_attachments')}
									</div>
								</div>
								{!this.isEdit && (
									<div class='d-flex align-items-center no-shrink mr-4'>
										<Sw green checked={this.isContinueCreate} vOn:change={this.toggleContinueCreate} />
										<div class='text__muted text__sm ml-2' vOn:click={this.toggleContinueCreate}>
											{this.$t('create_more')}
										</div>
									</div>
								)}
								<button
									type='button'
									disabled={!this.ticketData || this.loading}
									class='btn btn__success no-shrink'
									style='width: 120px'
									vOn:click={this.submit}
								>
									{this.isEdit ? this.$t('save_changes') : this.$t('create')}
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		)
	},
}
